/* The one Supabase client a page creates. It holds the session (Supabase's client stores and
   refreshes the tokens; nothing in the app touches them), so every part of a page has to
   share it: a second client would be a second, signed-out one for a moment. */

import {
  createSupabase,
  parseProviders,
  type OAuthProvider,
  type SupabaseClient,
} from "@preflop/api";

let client: SupabaseClient | null = null;

export function supabase(): SupabaseClient {
  if (client) return client;
  const url = import.meta.env.VITE_SUPABASE_URL;
  const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
  if (!url || !publishableKey)
    throw new Error(
      "VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY are not set. Copy .env.example to .env.local and fill them in.",
    );
  return (client = createSupabase({ url, publishableKey }));
}

/** The OAuth buttons this build shows. Empty until a provider is configured in Supabase. */
export const oauthProviders = (): OAuthProvider[] =>
  parseProviders(import.meta.env.VITE_AUTH_PROVIDERS);

/** The public half of the Turnstile widget's keys. Unset, the build has no captcha: a local
    stack, and production until the widget exists (docs/ops.md). */
export const turnstileSiteKey = (): string | undefined =>
  import.meta.env.VITE_TURNSTILE_SITE_KEY || undefined;

export const ACCOUNT_PAGE = "/account.html";
